import React from 'react';

export default function Component(props) {

  const { question, arrLen, answersList, ansNPSInput, surveyLanguageCode, surveyScreenData } = props;
  // let [showValue, handleValue ] = React.useState(0)

  // let showValue = false;
  // function handleValue(){}


  let [showValue2, handleValue2] = React.useState(111)

  let showValue = false;
  function handleValue() { }

  function CustomLabels(optionID, optionName, question) {
    let surveyLanguageCode = "customNPS";
    return (surveyLanguageCode !== '') ?
      (question && question.transl &&
        question.transl[surveyLanguageCode] &&
        question.transl[surveyLanguageCode][optionID]) ?
        question.transl[surveyLanguageCode][optionID] : optionName
      : optionName
  }


  function NPSName(optionID, optionName, surveyLanguageCode, question) {

    if (surveyLanguageCode) {
      return (surveyLanguageCode !== '') ?
        (question && question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode][optionID]) ?
          question.transl[surveyLanguageCode][optionID] : optionName
        : optionName
    } else {
      return (surveyLanguageCode !== '') ?
        (question && question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode].optionsList &&
          question.transl[surveyLanguageCode].optionsList[optionID]) ?
          question.transl[surveyLanguageCode].optionsList[optionID] : optionName
        : optionName
    }

  }

  function NPSColor(question) {

    let Color = "#a3a3a3";
    let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    if (showValue) {
      answer = showValue;
    }

    if (answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6) {
      Color = "#2074e3";
      if (answer === 1 || answer === 2) {
        Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied", question), surveyLanguageCode, question)
      }
      else if (answer === 3 || answer === 4) {
        Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied", question), surveyLanguageCode, question)
        console.log('Dissatisfied Name: ', Name)
      }
      else if (answer === 5 || answer === 6) {
        Name = NPSName("Neither", CustomLabels("Neither", "Neither", question), surveyLanguageCode, question)
      }
    }
    else if (answer === 7 || answer === 8) {
      Color = "#2074e3";
      Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied", question), surveyLanguageCode, question)
    }
    else if (answer === 9 || answer === 10) {
      Color = "#2074e3";
      Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied", question), surveyLanguageCode, question)
    }

    return {
      color: Color,
      name: Name
    }
  }

  function matchAnswer(answersList1, question1) {
    let value = "";
    if (answersList1 && answersList1.length > 0) {
      let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
      if (getIndex1 !== -1) {
        value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer ? answersList1[getIndex1].answer : "";
      }
    }
    return value
  }

  return (
    <>
      <div className="grid grid-cols-10 md:gap-4 gap-2 py-6  lg:text-lg text-sm mx-4">
        {[...Array(arrLen).keys()].map((value, index) =>
          <>
            {((value + 1).toString() === matchAnswer(answersList, question)) ?

              <span onMouseEnter={() => handleValue2((value + 1))} onClick={() => ansNPSInput((value + 1).toString(), question)} key={index}
                style={{ background: NPSColor(question, surveyLanguageCode).color }}
                className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 text-white border-2 border-gray-500  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
                {value + 1}
              </span>

              :
              <>
                {(value + 1) <= (showValue || parseInt(matchAnswer(answersList, question))) ?
                  <span onMouseEnter={() => handleValue2((value + 1))} onClick={() => ansNPSInput((value + 1).toString(), question)} key={index}
                    style={{ background: NPSColor(question, surveyLanguageCode).color }}
                    className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 text-white border-2 border-gray-100  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
                    {value + 1}
                  </span>
                  :
                  <span onMouseEnter={() => handleValue2((value + 1))} onClick={() => ansNPSInput((value + 1).toString(), question)} key={index}
                    className="bg-gray-100 rounded-md md:p-4 md:py-4 p-4 py-2 flex items-center border-2 border-gray-300 justify-center  hover:bg-gray-400 hover:text-white font-medium  cursor-pointer  px-3">
                    {value + 1}
                  </span>
                }
              </>
            }
          </>
        )}

      </div>


      <div className="flex justify-between w-[70%]">
        <span className="text-gray-600 text-sm px-4 font-semibold">{NPSName("Extremelydissatisfied", "Extremely dissatisfied", "customNPS", question)}</span>
        <span className="text-gray-600 text-sm px-4 font-semibold">{NPSName("Extremelysatisfied", "Extremely Satisfied", "customNPS", question)}</span>
      </div>


    </>
  );
}